var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.question))]),_c('editor',{ref:"queryEditor",attrs:{"mode":"text","theme":"chrome","value":_vm.value,"width":"100%","height":"250","options":_vm.editorOptions},on:{"input":function($event){return _vm.update($event)},"init":_vm.editorInit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }